import React from 'react';
import { DerivedFormulaTerm } from '../../types/apiGeneratedTypes';

interface BiomarkerCalculationDisplayProps {
  numeratorBiomarker?: {
    name?: string;
    value?: string | null;
  } | null;
  denominatorBiomarker?: {
    name?: string;
    value?: string | null;
  } | null;
  formulaType?: 'RATIO' | 'AFFINE' | null;
  formulaConstant?: number | null;
  formulaTerms?: DerivedFormulaTerm[] | null;
  termLabels?: Record<number, { name?: string; value?: string | null }>;
  resultValue: string;
  className?: string;
  labelClassName?: string;
  formulaClassName?: string;
}


export const BiomarkerCalculationDisplay: React.FC<BiomarkerCalculationDisplayProps> = ({
  numeratorBiomarker,
  denominatorBiomarker,
  formulaType,
  formulaConstant,
  formulaTerms,
  termLabels,
  resultValue,
  className = 'show-biomarker-calculation-section',
  labelClassName = 'show-biomarker-calculation-label',
  formulaClassName = 'show-biomarker-calculation-formula'
}) => {
  const isAffine =
    formulaType === 'AFFINE' || (!!formulaTerms && formulaTerms.length > 0);

  return (
    <div className={className}>
      <div className={labelClassName}>Calculation</div>
      <div className={formulaClassName}>
        {isAffine && formulaTerms?.length ? (
          <>
            {formulaTerms.map((term, index) => {
              const label = termLabels?.[term.biomarker_id];
              return (
                <React.Fragment key={`${term.biomarker_id}-${index}`}>
                  {index > 0 ? ' + ' : null}
                  <span className='show-biomarker-calculation-biomarker-name'>
                    ({term.coefficient}×{label?.name || `biomarker:${term.biomarker_id}`})
                  </span>
                  {label?.value != null && label.value !== '' && (
                    <span className='show-biomarker-calculation-value'>
                      {' ['}{label.value}{']'}
                    </span>
                  )}
                </React.Fragment>
              );
            })}
            {formulaConstant != null ? ` + ${formulaConstant}` : ''}
            {' = '}
          </>
        ) : numeratorBiomarker && denominatorBiomarker ? (
          <>
            <span className='show-biomarker-calculation-biomarker-name'>
              {numeratorBiomarker.name || 'N/A'}
            </span>
            {numeratorBiomarker.value && (
              <span className='show-biomarker-calculation-value'>
                {' ['}{numeratorBiomarker.value}{']'}
              </span>
            )}
            {' / '}
            <span className='show-biomarker-calculation-biomarker-name'>
              {denominatorBiomarker.name || 'N/A'}
            </span>
            {denominatorBiomarker.value && (
              <span className='show-biomarker-calculation-value'>
                {' ['}{denominatorBiomarker.value}{']'}
              </span>
            )}
            {' = '}
          </>
        ) : null}
        <span className='show-biomarker-calculation-result'>
          {resultValue}
        </span>
      </div>
    </div>
  );
};
